/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Status_Judge_SyncInputs */



/**
* | output |
* | --- |
* | "Judge directory sync" |
*
* @param {Admin_Status_Judge_SyncInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_status_judge_sync = /** @type {((inputs?: Admin_Status_Judge_SyncInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Status_Judge_SyncInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchronisation des arbitres")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronización de jueces")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sincronização de juízes")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizzazione giudici")
	return /** @type {LocalizedString} */ ("Judge directory sync")
});